import { useDynamicFlag } from '../services/launchDarkly';
import { isBattleVisible } from '../stores/slot-battle/battleSegmentGate';
import type { SlotBattle } from '../stores/slot-battle/types';
import { useStores } from '../stores/useStores';

/**
 * The battle this player may actually see, or null.
 *
 * Two gates, both required. The coin-scoped read says a battle exists; the run's own LaunchDarkly
 * flag must resolve to exactly this battle's segment key (see {@link isPlayerInBattleSegment}). No
 * value for the flag — still loading, or a run flag that is not client-side — hides the battle.
 * A settled closing is the exception: it is shown without the flag (see {@link isBattleVisible}).
 *
 * Every component reading a battle must be wrapped in `observer()` — this reads MobX observables.
 */
export function useSlotBattle(): SlotBattle | null {
  const { slotBattleStore } = useStores();
  const battle = slotBattleStore.battle;
  const segmentFromFlag = useDynamicFlag<string | undefined>(battle?.featureFlagKey, undefined);

  if (!battle) {
    return null;
  }

  return isBattleVisible(battle, segmentFromFlag) ? battle : null;
}
